<template>
  <div>
    <DrSearch v-bind:queryParams="queryParams" v-bind:fullDate="fullDate"/>
    <DrList   v-bind:queryParams="queryParams" v-bind:fullDate="fullDate" v-bind:fieldItems="fieldItems"/>
  </div>
</template>
<script>

import DrSearch from "./component/DrStatistics/DrSearch";
import DrList from "./component/DrStatistics/DrList";
import cSwitch from "../../../components/Switch";
import DatePicker from "vue2-datepicker";
const moment = require("moment");

export default {
  name: 'ContentStatistics',
  components: {
    cSwitch,
    DatePicker,
    DrSearch,
    DrList,
  },
  data() {
    return {

      fullDate: [],
      queryParams: {
        day_code: '',
        report_cate: '',
        sales_type: '',
        view_type: '',

        excel_rtype: 'DR',
        report_type_code: 'all',
        report_subtype_code: 'all',
        sort_by: 'stadate',
        sort_by_end: 'descend',
        option_type: 'all',

        start_date: '',
        end_date: '',
        keyword: '',
      },

      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        },
      }, {
        'dr_code': {
          'label': '보고서코드',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        },
        // 'visible': true,
      }, {
        'top_type_name': {
          'label': '대분류',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        },
        // 'visible': true,
      }, {
        'type_name': {
          'label': '소분류',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'report_name': {
          'label': '보고서명',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      },  {
        'custom_date': {
          'label': '출시일',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'report_reg_date': {
          'label': '등록일',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'sales_name': {
          'label': '판매구분',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'price_or_point': {
          'label': '금액',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      },{
        'view_name': {
          'label': '노출여부',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      } , {
        'total_cnt': {
          'label': 'total_cnt',
          'class': 'text-center',
          'sortable': true,
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }],
    }
  },
  computed: {
    listRows () {
      return this.items.length
    }
  },
  mounted: function() {
  },
  methods: {

    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },

    chagefield(view_type){
      let label_nm = '';
      if (view_type == 'VIEW'){
        label_nm = '조회수';
      } else if (view_type == 'RECOMMAND'){
        label_nm = '추천수';
      } else if (view_type == 'DOWNLOAD'){
        label_nm = '다운로드수';
      } else if (view_type == 'RESEARCH'){
        label_nm = '후속연구요쳥수';
      }

      this.fieldItems = this.fieldItems.map(item => {
        if (item.hasOwnProperty('total_cnt')) {
          item.total_cnt.label = label_nm; // 'your_new_label'을 원하는 새로운 레이블로 바꾸세요.
        }
        return item;
      });
    }
  }
}


</script>



// WEBPACK FOOTER //
// src/views/statistics/content/ContentStatistics.vue